<template>
  <div
    class="modal"
    for="my-modal"
    :class="{ 'modal-open': isModalShow }">
    <div class="modal-box relative p-2 overflow-y-auto justify-center max-h-screen w-full max-w-2xl">
      <!--header-->
      <div class="flex items-start justify-between p-3 border-b border-solid border-gray-200 rounded-t">
        <h3 class="text-2xl font-semibold">
          <slot name="header" />
        </h3>
        <button
          for="my-modal-2"
          class="btn btn-circle absolute right-2 top-2 btn-sm text-lg"
          @click.prevent="close">
          <i class="fas fa-times" />
        </button>
      </div>

      <!--body-->
      <div class="relative p-2 w-full">
        <slot name="body" />
      </div>

      <!--footer-->
      <div
        v-show="isFooterShow"
        class="flex items-center justify-end p-6 border-t border-solid border-gray-200 rounded-b">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        closeBtnText: {
            type: String,
            default: 'Close',
        },
        isModalShow: {
            type: Boolean,
            default: false,
        },
        isFooterShow: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close () {
            this.$emit('close')
        },
    },
}
</script>
